import { twMerge } from 'tailwind-merge';
import { useCurrentProfile } from '@/hooks/useStore';
import Card from '@/components/Card';
import ProfilePicture from '@/components/ProfilePicture';
import Title from '@/components/Title';
import { renderProfileName } from '@/utils/strings';
import IconButton from '@/components/IconButton';
import { NotificationsIcon, SettingsIcon } from '@/icons';
import { classes } from './utils';

export type WelcomeCardProps = {
  className?: string;
};

export default function WelcomeCard({ className }: WelcomeCardProps) {
  const profile = useCurrentProfile();

  return (
    <Card className={twMerge(classes.card, className)}>
      <div className={classes.userWrapper}>
        {profile && <ProfilePicture size={65} profile={profile} />}
        <div className={classes.userText}>
          <div className={classes.welcome}>Welcome back!</div>
          {profile && <Title size="lg">{renderProfileName(profile)}</Title>}
        </div>
      </div>
      <div className={classes.buttonsWrapper}>
        <IconButton
          className={classes.button}
          icon={<NotificationsIcon className={classes.icon} />}
        />
        <IconButton
          className={classes.button}
          icon={<SettingsIcon className={classes.icon} />}
        />
      </div>
    </Card>
  );
}
